import React from "react";

const LogoutStatus = ({ title, message, children }) => (
  <main className="min-vh-100 d-flex align-items-center justify-content-center bg-light p-4">
    <section
      className="card shadow-sm p-4 text-center"
      style={{ maxWidth: 520, width: "100%" }}
      aria-live="polite"
    >
      <div className="text-primary fw-bold mb-3">PIERS</div>
      <h1 className="h4">{title}</h1>
      <p className="text-muted my-3">{message}</p>
      <div>{children}</div>
    </section>
  </main>
);
export default LogoutStatus;
